"use strict";

var _regeneratorRuntime = require("/drone/src/node_modules/@babel/runtime/regenerator/index.js");

var _classCallCheck = require("/drone/src/node_modules/@babel/runtime/helpers/classCallCheck.js");

var _createClass = require("/drone/src/node_modules/@babel/runtime/helpers/createClass.js");

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var rxjs_1 = require("rxjs");

var auth_events_1 = __importDefault(require("./auth.events"));

var AUTH_DEFAULT_ROUTE = '/';
var AUTH_REDIRECT_STORAGE = 'AUTH_REDIRECT_STORAGE';
var AUTH_STORAGE = 'cas-js:user';
var BOOSTRAP_CONFIG_DEFAULT_OPTIONS = {
  signinRedirect: true,
  revalidateOnFocus: true,
  revalidateOnReconnect: true
};

var Bootstrap = /*#__PURE__*/function () {
  function Bootstrap(authService, config) {
    var _this = this;

    _classCallCheck(this, Bootstrap);

    this.config = Object.assign(Object.assign({}, BOOSTRAP_CONFIG_DEFAULT_OPTIONS), config);
    this.authService = authService;
    this.subject = new rxjs_1.Subject();
    this.subscribe = this.subject.subscribe.bind(this.subject);
    this.unsubscribe = this.subject.unsubscribe.bind(this.subject);
    this.authRenewRoute = new URL(this.authService.userManager.settings.silent_redirect_uri).pathname;
    this.authLoginRoute = new URL(this.authService.userManager.settings.redirect_uri).pathname;
    this.authLogoutRoute = new URL(this.authService.userManager.settings.post_logout_redirect_uri).pathname;
    this.authRoutes = [this.authRenewRoute, this.authLoginRoute, this.authLogoutRoute];

    this.accessTokenExpiringListener = function () {
      return auth_events_1.default.dispatchRenew();
    };

    this.silentRenewErrorListener = function () {
      return auth_events_1.default.dispatchRenewError();
    };

    this.userLoadedListener = function () {
      if (location.pathname === _this.authLoginRoute) _this.getUser();else _this.authenticate();
    };

    this.visibilityChangeListener = function () {
      if (document.visibilityState === 'visible') {
        _this.authenticate();
      }
    };
  }

  _createClass(Bootstrap, [{
    key: "start",
    value: function start() {
      var newConfig = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      this.config = Object.assign(Object.assign({}, this.config), newConfig);
      this.authenticate();

      if (this.authService.userManager.settings.automaticSilentRenew) {
        this.authService.userManager.startSilentRenew();
        this.authService.userManager.events.addSilentRenewError(this.silentRenewErrorListener);
      }

      this.authService.userManager.events.addAccessTokenExpiring(this.accessTokenExpiringListener);
      this.authService.userManager.events.addUserLoaded(this.userLoadedListener);

      if (this.config.revalidateOnReconnect) {
        window.addEventListener('online', this.authenticate);
      }

      if (this.config.revalidateOnFocus) {
        document.addEventListener('visibilitychange', this.visibilityChangeListener);
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      if (this.authService.userManager.settings.automaticSilentRenew) {
        this.authService.userManager.stopSilentRenew();
        this.authService.userManager.events.removeSilentRenewError(this.silentRenewErrorListener);
      }

      this.authService.userManager.events.removeAccessTokenExpiring(this.accessTokenExpiringListener);
      this.authService.userManager.events.removeUserLoaded(this.userLoadedListener);

      if (this.config.revalidateOnReconnect) {
        window.removeEventListener('online', this.authenticate);
      }

      if (this.config.revalidateOnFocus) {
        document.removeEventListener('visibilitychange', this.visibilityChangeListener);
      }
    }
  }, {
    key: "authenticate",
    value: function authenticate() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this2 = this;

        var redirectRoute, _redirectRoute;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(new URLSearchParams(location.search).get('error') === 'login_required')) {
                  _context.next = 3;
                  break;
                }

                this.logout();
                return _context.abrupt("return");

              case 3:
                if (!(location.pathname === this.authRenewRoute || location.pathname === this.authLoginRoute)) {
                  _context.next = 6;
                  break;
                }

                _context.next = 6;
                return this.authService.signinCallback().catch(function () {
                  return _this2.signinRedirect();
                });

              case 6:
                if (!(location.pathname === this.authLogoutRoute)) {
                  _context.next = 12;
                  break;
                }

                _context.next = 9;
                return this.authService.signoutCallback();

              case 9:
                redirectRoute = sessionStorage.getItem(AUTH_REDIRECT_STORAGE);
                window.location.href = redirectRoute || AUTH_DEFAULT_ROUTE;
                return _context.abrupt("return");

              case 12:
                if (!(this.authRoutes.indexOf(location.pathname) >= 0)) {
                  _context.next = 17;
                  break;
                }

                _redirectRoute = sessionStorage.getItem(AUTH_REDIRECT_STORAGE);
                window.location.href = _redirectRoute || AUTH_DEFAULT_ROUTE;
                sessionStorage.removeItem(AUTH_REDIRECT_STORAGE);
                return _context.abrupt("return");

              case 17:
                this.getUser();

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));
    }
  }, {
    key: "signinSilent",
    value: function signinSilent() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var user;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                auth_events_1.default.dispatchRenew();
                _context2.next = 4;
                return this.authService.signinSilent();

              case 4:
                user = _context2.sent;
                return _context2.abrupt("return", user);

              case 8:
                _context2.prev = 8;
                _context2.t0 = _context2["catch"](0);
                this.signinRedirect();
                return _context2.abrupt("return", null);

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 8]]);
      }));
    }
  }, {
    key: "signinRedirect",
    value: function signinRedirect() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var currRoute;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (this.config.signinRedirect) {
                  _context3.next = 2;
                  break;
                }

                return _context3.abrupt("return");

              case 2:
                currRoute = this.getCurrentRoute();
                localStorage.removeItem(AUTH_STORAGE);
                sessionStorage.setItem(AUTH_REDIRECT_STORAGE, currRoute);
                _context3.next = 7;
                return this.authService.signinRedirect();

              case 7:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
    }
  }, {
    key: "getUser",
    value: function getUser() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
        var user;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return this.authService.getUser();

              case 2:
                user = _context4.sent;

                if (user) {
                  _context4.next = 6;
                  break;
                }

                _context4.next = 6;
                return this.signinRedirect();

              case 6:
                if (!((user === null || user === void 0 ? void 0 : user.expired) || !user && !this.config.signinRedirect)) {
                  _context4.next = 10;
                  break;
                }

                _context4.next = 9;
                return this.signinSilent();

              case 9:
                user = _context4.sent;

              case 10:
                if (user) localStorage.setItem(AUTH_STORAGE, JSON.stringify(user));
                this.subject.next(user);
                auth_events_1.default.dispatchUser(user);
                return _context4.abrupt("return", user);

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));
    }
  }, {
    key: "logout",
    value: function logout() {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var currRoute;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                currRoute = this.getCurrentRoute();
                localStorage.removeItem(AUTH_STORAGE);
                sessionStorage.setItem(AUTH_REDIRECT_STORAGE, currRoute);
                _context5.next = 5;
                return this.authService.signoutRedirect();

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));
    }
  }, {
    key: "getCurrentRoute",
    value: function getCurrentRoute() {
      return this.authRoutes.indexOf(location.pathname) < 0 ? "".concat(location.pathname).concat(location.search) : AUTH_DEFAULT_ROUTE;
    }
  }]);

  return Bootstrap;
}();

exports.default = Bootstrap;